export default "<div class=\"version\">\n    <span>v{{version}}</span>\n</div>";